<template>
<div id="faqs">
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-flex xs12>
                <v-layout wrap class="text-xs-center">
                    <v-flex xs12 ma-0 pa-0>
                        <v-card color="orange" class="customcard">
                            <v-card-text class="py-0 my-0">
                                <v-flex 12 class="text-xs-right">
                                    <!--<v-btn outline class="btn_txtoutline" :href="`mailto:${contactEmailAddress}`"><i class="fab fa-telegram-plane"></i> CONTACT</v-btn>-->

                                </v-flex>
                                <v-flex xs8 offset-xs2>
                                  <h2 py-0 my-0>LOADMAX VIDEO TUTORIALS</h2>
                                  <p py-0 my-0>Tutorials from the LOADMAX headquarters to teach you how to maximize your business's potential.</p>
                                </v-flex>


                            </v-card-text>
                        </v-card>
                          <v-card-text>
                             <v-layout wrap class="text-xs-center">
                               <v-flex xs4 class="text-xs-center">
                              <iframe src="https://player.vimeo.com/video/347545020" width="100%"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                              <p><a href="https://vimeo.com/347545020">James Dyke, President of LOADMAX</a> from <a href="https://vimeo.com/user97160085">LOADMAX</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
                              </v-flex>
                               <v-flex xs4 class="text-xs-center">
                              <iframe src="https://player.vimeo.com/video/347545020" width="100%"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                              <p><a href="https://vimeo.com/347545020">James Dyke, President of LOADMAX</a> from <a href="https://vimeo.com/user97160085">LOADMAX</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
                              </v-flex>
                               <v-flex xs4 class="text-xs-center">
                              <iframe src="https://player.vimeo.com/video/347545020" width="100%"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                              <p><a href="https://vimeo.com/347545020">James Dyke, President of LOADMAX</a> from <a href="https://vimeo.com/user97160085">LOADMAX</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
                              </v-flex>
                               <v-flex xs4 class="text-xs-center">
                              <iframe src="https://player.vimeo.com/video/347545020" width="100%"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                              <p><a href="https://vimeo.com/347545020">James Dyke, President of LOADMAX</a> from <a href="https://vimeo.com/user97160085">LOADMAX</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
                              </v-flex>
                               <v-flex xs4 class="text-xs-center">
                              <iframe src="https://player.vimeo.com/video/347545020" width="100%"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                              <p><a href="https://vimeo.com/347545020">James Dyke, President of LOADMAX</a> from <a href="https://vimeo.com/user97160085">LOADMAX</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
                              </v-flex>
                               <v-flex xs4 class="text-xs-center">
                              <iframe src="https://player.vimeo.com/video/347545020" width="100%"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                              <p><a href="https://vimeo.com/347545020">James Dyke, President of LOADMAX</a> from <a href="https://vimeo.com/user97160085">LOADMAX</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
                              </v-flex>
                           </v-layout>
                          </v-card-text>
                        <v-card>
                            <v-card-text class="py-0 my-0">

                            </v-card-text>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-flex>
        </v-layout>

    </v-container>
</div>
</template>

<script>
import config from "../config";
import GoogleAds from "@/pages/widgets/GoogleAds";
export default {
    components: {
        GoogleAds,
    },
    created() {
        this.isImr = this.$store.state.user.isImr;
    },
    data: () => ({
        contactEmailAddress: config.contactEmailAddress,
        isImr: false
    })
};
</script>
<style lang="stylus">
iframe
  background:#000;
  max-width:100%!important; 
  
</style>



// WEBPACK FOOTER //
// src/pages/tutorials.vue